import { render, staticRenderFns } from "./AccountCertificateFormType.vue?vue&type=template&id=73483f8a&scoped=true&"
import script from "./AccountCertificateFormType.vue?vue&type=script&lang=ts&"
export * from "./AccountCertificateFormType.vue?vue&type=script&lang=ts&"
import style0 from "./AccountCertificateFormType.vue?vue&type=style&index=0&id=73483f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73483f8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
